import { SealOfApprovalAndNorm } from './SealOfApprovalAndNorm';

export default SealOfApprovalAndNorm;
